export default __webpack_public_path__ + "assets/team-2.jpg";